import { render, staticRenderFns } from "./points_task_trial.vue?vue&type=template&id=771d6eea&scoped=true"
import script from "./points_task_trial.vue?vue&type=script&lang=js"
export * from "./points_task_trial.vue?vue&type=script&lang=js"
import style0 from "./points_task_trial.vue?vue&type=style&index=0&id=771d6eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d6eea",
  null
  
)

export default component.exports